'use strict';

//const {COLUMN_HIGHT} = require('constants/AppConstants');
const COLUMN_HIGHT = 50;
const {delay} = require('lodash/function');
const SessionStore = require('stores/SessionStore');

let relativeToViewport;

const style = function (element, prop) {
    return typeof getComputedStyle !== 'undefined'
        ? getComputedStyle(element, null).getPropertyValue(prop)
        : element.style[prop];
};

const overflow = function (element) {
    return style(element, 'overflow') + style(element, 'overflow-y') + style(element, 'overflow-x');
};

function isRelativeToViewport() {
    if (relativeToViewport != null) return relativeToViewport;

    var x = window.pageXOffset ? window.pageXOffset + window.innerWidth - 1 : 0;
    var y = window.pageYOffset ? window.pageYOffset + window.innerHeight - 1 : 0;
    if (x === 0 && y === 0) return true;

    // Test with a point larger than the viewport. If it returns an element,
    // then that means elementFromPoint takes page coordinates.
    return relativeToViewport = !document.elementFromPoint(x, y);
}

var Util = {

    elementFromPoint(x, y) {
        if (!isRelativeToViewport()) x += window.pageXOffset, y += window.pageYOffset;

        return document.elementFromPoint(x, y);
    },

    closestFixed(elm) {
        if (window.getComputedStyle(elm).position === 'fixed') {
            return elm;
        } else {
            if (elm.parentElement && !/body|html/.test(elm.parentElement.tagName.toLowerCase())) {
                return this.closestFixed(elm.parentElement);
            } else {
                return null;
            }
        }
    },

    scrollTo(to, scrolleableElement, callback) {
        if (scrolleableElement) {
            scrolleableElement.scrollTop = to;
        } else {
            window.scroll(0, to);
        }

        if (callback && typeof callback === 'function') {
            delay(callback, 1000);
        }
    },

    elementScrollTop(element, manualOffset) {
        var scrollTopValue = 0;
        if (element && element.offsetParent) {
            do {
                if (manualOffset) {
                    scrollTopValue += element.offsetTop + manualOffset;
                } else {
                    scrollTopValue += element.offsetTop;
                }
            } while (element === element.offsetParent);
        }
        return scrollTopValue;
    },

    elementScrollBottom(element, manualOffset) {
        var scrollTopValue = 0;
        if (element && element.offsetParent) {
            do {
                if (manualOffset) {
                    scrollTopValue += ((element.offsetTop + manualOffset) - window.innerHeight) + SessionStore.getHeaderHigh() + COLUMN_HIGHT;
                } else {
                    scrollTopValue += ((element.offsetTop) - window.innerHeight) + SessionStore.getHeaderHigh() + COLUMN_HIGHT;
                }
            } while (element === element.offsetParent);
        }
        return scrollTopValue;
    },

    disableScrolling(){
        if (window.addEventListener) // older FF
            window.addEventListener('DOMMouseScroll', preventDefault, false);
        window.onwheel = preventDefault; // modern standard
        window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
        window.ontouchmove = preventDefault; // mobile
        document.onkeydown = preventDefaultForScrollKeys;
    },

    enableScrolling(){
        if (window.removeEventListener)
            window.removeEventListener('DOMMouseScroll', preventDefault, false);
        window.onmousewheel = document.onmousewheel = null;
        window.onwheel = null;
        window.ontouchmove = null;
        document.onkeydown = null;
    },

    getParentScroll(element) {
        if (!(element instanceof HTMLElement)) {
            return window;
        }

        var parent = element;

        while (parent) {
            if (!parent.parentNode) {
                return window;
            }

            if (/(scroll|auto)/.test(overflow(parent))) {
                return parent;
            }

            parent = parent.parentNode;
        }

        return window;
    },
    
    getHeaderTankClickedId(clientX) {
        const MAX_PIXEL_CHECKED = 500;
        for (let positionY = 0; positionY < MAX_PIXEL_CHECKED; positionY += 2) {
            const currentElementClicked = this.elementFromPoint(clientX, positionY); // The distance of the header
            if (currentElementClicked.classList.contains('fixed-header-tank-name') || currentElementClicked.classList.contains('react-grid-item')) {
                return currentElementClicked.getAttribute('data-tank-id');
            }
        }
    }

};


var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault() {
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}

module.exports = Util;



/** WEBPACK FOOTER **
 ** ./src/utils/PositionUtils.js
 **/